export enum FrequencyEnum {
    UNIQUE=1,
    DAYLI=2,
    WEEKLY=3,
    CYCLIC=4,
}

export enum FrequencyEnumText {
    UNIQUE='unique',
    DAYLI='daily',
    WEEKLY='weekly',
    CYCLIC='cyclical',
}

export enum SerieEnumText {
    UNIQUE='única vez',
    DAYLI='diaria',
    WEEKLY='semanal',
    CYCLIC='ciclica',
}

export enum SerieEnumTextUper {
    UNIQUE='Única vez',
    DAYLI='Diaria',
    WEEKLY='Semanal',
    CYCLIC='Ciclica',
}

export enum ScheduleEnumType {
    SERIE=1,
    RECURRENT=2,
    UNIQUE=3
}

export enum FrequencyEnumTable {
    FRRE=1,
    UNIQUE=2,
    DAYLI=3,
    WEEKLY=4,
    CYCLIC=5,
}